<template>
  <div class="scheduleList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="btnclick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @uploadSuc="loadSendTo" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
import Qs from 'qs'
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import UPDATE from '@/components/page/update'
import DataUtil from '@/utils/dataUtil'

//发送状态
const scheduleStatusList = [
  {key:0, value:"未发送"},
  {key:1, value:"已发送"},
]

//全部短信模板
//key = templateId
//value = templateName
//status
let allTemplateList = []

//有效短信模板
//key = templateId
//value = templateName
//templateContent
let activeTemplateList = []

export default {
  name: 'scheduleList',
  components: {
    FORM,
    tablePage,
    UPDATE
  },
  data() {
    return {
      queryData: {},
      /*form查询表单*/
      formData: {
        hasLable: true,
        cols: []
      },
      /*table查询记录*/
      pageData: {
        queryUrl: Url.sms.scheduleList,
        selection: true,
        sequence: false,
        method: 'get',
        cols: [
          { title: '预定发送时间', field: 'scheduleTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          { title: '模板名称', field: 'templateId', render: (data, full) => {
              let t = allTemplateList.find(e => e.key === data)
              if (t == undefined) {
                return ""
              } else {
                if (t.status == 0) {
                  return "<span style='color:red'>" + t.value + "</span>"
                } else {
                  return t.value
                }
              }
            }
          },
          { title: '客戶账号', field: 'sendTo' },
          { title: '发送状态', field: 'scheduleStatus', width: '100px', render: (data, full) => {return scheduleStatusList.find(e => e.key === data).value} },
          { title: '创建时间', field: 'createTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          { title: '更新时间', field: 'updateTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.edit'),
                click: window.$t('common.edit'),
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'analyse:sms:editNoticeSchedule',
                hidden: (data, full) => {return full.scheduleStatus != 0},
              },
            ]
          }
        ]
      },
      /*add或update浮窗表单*/
      updateData: {
        cols: []
      },
      /*其它*/
      selectData: {
        ids: ''
      },
      sendType: 1, //通知短信
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    /*form按钮点击事件*/
    formclick(clickName, data) {
      if (clickName == window.$t('common.search')) {
        data.status = 1 //显示
        data.sendType = this.sendType
        data.scheduleTimeStart = data.scheduleTimeStart ? new Date(data.scheduleTimeStart).getTime() : ''
        data.scheduleTimeEnd = data.scheduleTimeEnd ? new Date(data.scheduleTimeEnd).getTime() : ''
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)

      } else if (clickName == window.$t('common.addNew')) {
        this.$refs.childUpdate.open()

      } else if (clickName == window.$t('common.hide')) {
        if (this.selectData.ids == "") {
          this.$message.error('未选取记录')
        } else {
          this.$confirm('确定隱藏已选取的记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataChange(Url.sms.scheduleHide, this.selectData, res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.$refs.childTable.defaultQueryData(this.queryData)
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {})
        }
      }
    },

    /*table按钮点击事件*/
    btnclick(clickName, row) {
      if (clickName == window.$t('common.edit')) {
        let t = activeTemplateList.find(e => e.key === row.templateId)
        if (t == undefined) {
          row.templateId = ""
          row.templateContent = ""
        } else {
          row.templateContent = t.templateContent
        }
        this.$refs.childUpdate.open(row)
      }
    },

    /*add或update提交数据触发事件*/
    submit(model) {
      this.dataChange(Url.sms.scheduleSave, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultQueryData(this.queryData)
        } else {
          this.$message.error(res.message)
        }
      })
    },

    /*其它*/
    checkbox(row) {
      this.selectData.ids = row.map(key => key.id).join(",");
    },
    loadSendTo(col, result, cols) {
      for (let i in cols) {
        if (cols[i].field == 'sendTo') {
          let newCol = JSON.parse(JSON.stringify(cols[i]))
          if (result != null) {
            newCol.data = result
          } else {
            newCol.data = ""
          }
          cols.splice(i, 1, newCol)
        }
      }
    },
    loadTemplateContent(model, cols, col) {
      let t = activeTemplateList.find(e => e.key === col.data)
      if (t == undefined) {
        cols.find(c => c.field === 'templateContent').data = ""
      } else {
        cols.find(c => c.field === 'templateContent').data = t.templateContent
      }
    },
  },
  created() {
    //初始化先取得模板列表
    this.$axios.get(Url.sms.templateList + 
        "?sendType=" + this.sendType + 
        "&pageNum=1" + 
        "&pageSize=-1").then(res => {

      if (res.code == 0 && res.result) {
        allTemplateList = [];
        activeTemplateList = [];
        let data = JSON.parse(JSON.stringify(res.result.list));
        for (let i in data) {
          allTemplateList.push({
            key: data[i].id,
            value: data[i].templateName,
            status: data[i].status,
          });
          if (data[i].status == 1) {
            activeTemplateList.push({
              key: data[i].id,
              value: data[i].templateName,
              templateContent: data[i].templateContent,
            });
          }
        }
      }

      /*表单初始化*/
      this.formData.cols = [
        { title: '短信模板', field: 'templateId', type: 2, optionList: activeTemplateList },
        { title: '模板名称', field: 'templateName' },
        { title: '模板内容', field: 'templateContent' },
        { title: '发送状态', field: 'scheduleStatus', type: 2, optionList: scheduleStatusList },
        { title: '预定发送时间', field: 'time', type: 6, format: 'yyyy-MM-dd HH:mm:ss', startEndParam: ['scheduleTimeStart', 'scheduleTimeEnd'] },
        { click: window.$t('common.search'), icon: 'el-icon-search' },
        { click: window.$t('common.addNew'), icon: 'el-icon-circle-plus-outline', auth: 'analyse:sms:addNoticeSchedule' },
        { click: window.$t('common.hide'), icon: 'el-icon-delete', auth: 'analyse:sms:hideNoticeSchedule' },
      ]
      this.updateData.cols = [
        { title: '序号', field: 'id', hidden: true },
        { title: '发送类型', field: 'sendType', data: this.sendType, hidden: true },
        { title: '汇入客戶列表', field: 'file', type: 11, action: Url.sms.scheduleExtractCustomer, showFileName: false, downUrl: 'https://img.cfd139.com/source/downModel/用戶账号.xlsx' },
        { title: '客戶账号', field: 'sendTo', textType: 'textarea', placeholder: '客戶账号 (逗号分隔)', required: true },
        { title: '模板名称', field: 'templateId', type: 2, optionList: activeTemplateList, change: this.loadTemplateContent, required: true },
        { title: '模板内容', field: 'templateContent', textType: 'textarea', readonly: true },
        { title: '预定发送时间', field: 'scheduleTime', type: 5 },
      ]
    })
  }
}
</script>
